module.exports = __webpack_public_path__ + "img/art.d25a0dac.svg";